import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { BlockItem, BlockSelect, BlockSelectType } from 'components/BlockSelect'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'
import { SRPRS } from 'Icon/srprs'
import {
  ActionModalInnerComponentProps,
  withActionListModal,
} from '../../../../elements/modals/ActionListModal'
import Content from '../../../shared/content'

import ListHeader from 'components/ListHeader'
import {
  DaysAndLoction,
  DayOption,
} from '../../../../data/models/funnelOrder/days'

import {
  getDaysFromValue,
  getNightsFromValue,
} from '../../../../data/models/funnelOrder/days'
import { AppState } from '../../../../data/state'
import { optionSelection } from '../../../../tracking/actions/optionSelection'

interface NumberOfDaysModalProps {
  options: DayOption[]
  children?: React.ReactNode | undefined
}

interface NumberOfDaysModalState {
  days: number
  locations: number
  hideBlock: boolean
}

class NumberOfDaysModal extends React.Component<
  ActionModalInnerComponentProps & NumberOfDaysModalProps,
  NumberOfDaysModalState
> {
  constructor(
    props: ActionModalInnerComponentProps & NumberOfDaysModalProps,
  ) {
    super(props)
    this.state = {
      days: props.value.days || 3,
      locations: props.value.locations || 2,
      hideBlock: false,
    }
  }

  public render() {
    const numDays = this.props.options;

    return (
      <Modal
        size="xl"
        animationType="1"
        sticky
        onDismiss={this.handleClose}
        disableOutsideClick={this.props.disableOutsideClick}
      >
        <ModalHeader icon={SRPRS.calendarColored()}>
          <Content contentKey="cities-and-days">Cities and Days</Content>
        </ModalHeader>
        <div className="content">
          <div className="margin-b-m">
            <div className="margin-b-s">
              <ListHeader noMarginLeft={true} isUppercase={true}>
                <strong>
                  <Content contentKey="number-days">NUMBER OF DAYS</Content>
                </strong>
              </ListHeader>
            </div>
            <BlockSelect
              model="days"
              type={BlockSelectType.row}
              animated={true}
              value={this.state.days}
              nrCols={[numDays.length]}
              onChange={this.handleDaysChange}
            >
              {!this.state.hideBlock
                ? numDays.map(day => (
                  <BlockItem
                    type={`checkbox`}
                    value={day.days}
                    key={day.days}
                    label={day.days.toString()}
                  />
                ))
                : null}
            </BlockSelect>
          </div>
          {this.props.children}
        </div>
        <ModalFooter onClose={this.handleClose} onSave={this.handleSave} />
      </Modal>
    )
  }

  private handleSave = () => {
    if (this.props.onSave !== undefined) {
      this.props.onSave({
        days: this.state.days,
        locations: this.state.locations,
      })
    }
  }

  private handleClose = () => {
    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  private handleDaysChange = (value: string, checked: boolean) => {
    this.setState({
      days: +value
    })
  }
}

const LocationsAndDays = connect(
  (state: AppState) => ({
    value: {
      days: state.funnelOrder.days,
      locations: state.funnelOrder.locations,
    },
  }),
  dispatch => ({
    onChange: (value: DaysAndLoction) => {
      optionSelection('days', value.days)
      dispatch(actions.change('funnelOrder.days', value.days))
    },
  }),
  (stateProps, dispatchProps, ownProps: NumberOfDaysModalProps) => ({
    value: Object.assign(stateProps.value, { options: ownProps.options }),
    ...ownProps,
    onChange: (value: DaysAndLoction) => {
      if (
        stateProps.value.days !== value.days
      ) {
        dispatchProps.onChange(value)
      }
    },
  }),
)(
  withActionListModal<NumberOfDaysModalProps>(NumberOfDaysModal, {
    icon: SRPRS.calendarColored(),
    subject: (
      <Content addNode contentKey="cities-and-days">
        Cities and Days
      </Content>
    ),
    getValue: getDaysFromValue,
    getSubValue: getNightsFromValue,
  }),
)

export default LocationsAndDays
